
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("contact/contacts_list_item",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexrow class=\"border-pane\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" data-fw-onclick=\"controllerselect\"><img class=\"fw-avatar\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"thumb") : depth0), depth0))
    + "\" /><flexauto><line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"displayName") : depth0), depth0))
    + "</line><line class=\"sub4\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"function") : depth0), depth0))
    + "</line></flexauto></flexrow>";
},"useData":true});
export default TPL;